import React, { useEffect, useState } from "react";
import {
  DownOutlined,
  HomeOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Image,
  Layout,
  Menu,
  Modal,
  Typography,
  theme,
} from "antd";
import SideMenu from "./SideMenus";
import SideIllustration from "./SideIllustration";
import NotificationBell, { TOAST_KEY } from "./NotificationBell";
import ContentBody from "./ContentBody";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Login from "../Pages/Auth/Login";
import { api_URL } from "../Services/Constantes";
import defaultImage from "../Pages/Image/default-image.png"; // Chemin vers l'image par défaut
import logoEntete from "../Pages/Image/logoSoc.jpg"; // Chemin vers l'image par défaut




const { Header, Sider, Footer, Content } = Layout;
const LayoutComp = () => {
  const logoBlue = "#114b88";
  const logoBlueLight = "#1f5fa8";
  const logoOrange = "#f1ce57";

  const [modal, contextHolder] = Modal.useModal();
  const [collapsed, setCollapsed] = useState(false);
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const location = useLocation();

  const matipm = localStorage.getItem("matipm");

  // const photoUrl = `${api_URL}/images/photos/${matipm}.jpg`;

  const navigate = useNavigate();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const numcont = localStorage.getItem("numcont");
  const handlepagemdp = () => {
    navigate(`/profil`);
  };
  const displayName = [prenom, nom].filter(Boolean).join(" ") || "Membre IPM";

  useEffect(() => {
    const storedUsername = localStorage.getItem("prenom");
    if (storedUsername) {
      setPrenom(storedUsername);
    }
  }, []);

  useEffect(() => {
    const storedRolename = localStorage.getItem("nom");
    if (storedRolename) {
      setNom(storedRolename);
    }
  }, []);

  useEffect(() => {
    let logoutTimer;

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      const sessionTimeout = parseInt(
        localStorage.getItem("sessionDuration") || "1800000", // 30 minutes
        10
      );

      // Si la session a expiré et que le modal n'est pas encore affiché
      const sessionExpired = localStorage.getItem("sessionExpired");
      if (sessionExpired && !isModalVisible) {
        showLogoutModal(); // Affiche le modal si la session a expiré
        return;
      }

      // Redémarre le timer si le modal n'est pas déjà visible
      logoutTimer = setTimeout(() => {
        // Stocke dans le localStorage que la session a expiré
        localStorage.setItem("sessionExpired", "true");
        if (!isModalVisible) {
          showLogoutModal();
        }
      }, sessionTimeout);
    };

    const showLogoutModal = () => {
      setIsModalVisible(true); // Indiquer que le modal est visible
      Modal.confirm({
        title: "Votre session est terminée",
        content:
          "Pour continuer à utiliser l'application, veuillez vous déconnecter puis vous reconnecter.",
        okText: "Se Déconnecter",
        onOk: () => {
          localStorage.removeItem("auth");
          localStorage.removeItem("user_connect");
          localStorage.removeItem(TOAST_KEY);
          localStorage.removeItem("notifs_lues");
          localStorage.removeItem("sessionExpired"); // Retire l'indicateur de session expirée
          setIsModalVisible(false); // Réinitialise l'état pour permettre de réafficher le modal après reconnexion
          navigate("/login");
          window.location.reload(true); // Recharge la page après reconnexion
          return <Login />;
        },
        cancelButtonProps: { style: { display: "none" } },
      });
    };

    // Ajouter des écouteurs d'événements pour réinitialiser le timer
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);

    // Initialiser le timer
    resetTimer();

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      clearTimeout(logoutTimer);
    };
  }, [isModalVisible]); // Ajouter isModalVisible comme dépendance

  const logout = () => {
    modal.confirm({
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span
            style={{
              width: 42,
              height: 42,
              borderRadius: "50%",
              background: "rgba(220, 38, 38, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <LogoutOutlined style={{ fontSize: 20, color: "#dc2626" }} />
          </span>
          <span style={{ fontWeight: 700, fontSize: 17, color: "#0f172a" }}>
            Déconnexion
          </span>
        </div>
      ),
      content: (
        <div style={{ paddingLeft: 54, paddingTop: 4 }}>
          <Typography.Text style={{ fontSize: 14, color: "#475569" }}>
            Vous êtes sur le point de quitter votre espace IPM.
          </Typography.Text>
          <br />
          <Typography.Text style={{ fontSize: 13, color: "#94a3b8", marginTop: 4, display: "block" }}>
            Vos données sont sauvegardées. Vous pouvez vous reconnecter à tout moment.
          </Typography.Text>
        </div>
      ),
      okText: "Se déconnecter",
      okButtonProps: {
        danger: true,
        type: "primary",
        size: "large",
        style: {
          background: "linear-gradient(135deg, #b91c1c, #dc2626)",
          border: "none",
          fontWeight: 700,
          fontSize: 14,
          borderRadius: 8,
          height: 42,
          paddingInline: 24,
          boxShadow: "0 4px 14px rgba(220, 38, 38, 0.45)",
          letterSpacing: "0.3px",
        },
      },
      cancelText: "Rester connecté",
      cancelButtonProps: {
        style: {
          borderRadius: 8,
          height: 38,
          paddingInline: 20,
          fontWeight: 500,
        },
      },
      centered: true,
      icon: null,
      onOk: () => {
        localStorage.clear();
        navigate("/login");
        window.location.reload();
      },
    });
  };

  /*   const logout = () => {
    console.log("Fonction logout simplifiée appelée"); // Vérifiez ce log
    localStorage.clear();
    console.log("localStorage après clear :", localStorage);
    window.location.href = "/login"; // Redirection
  };*/
  const gestionMenu = (
    <Menu
      style={{
        borderRadius: 16,
        padding: "0 0 8px",
        overflow: "hidden",
        boxShadow: "0 18px 48px rgba(15, 23, 42, 0.18)",
        border: "1px solid rgba(148, 163, 184, 0.12)",
      }}
    >
      <Menu.Item
        key="user-info"
        disabled
        style={{
          cursor: "default",
          padding: "18px 20px",
          background:
            `linear-gradient(135deg, ${logoBlue}1f 0%, ${logoBlueLight}2e 100%)`,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div
            style={{
              width: 56,
              height: 56,
              padding: 3,
              borderRadius: "50%",
              background:
                `linear-gradient(135deg, ${logoBlue}b3, ${logoBlueLight}b3)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              src={`${api_URL}Participant/getPhoto/${numcont}`}
              alt="Membre"
              preview={false}
              width={50}
              height={50}
              style={{
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #ffffff",
              }}
              onError={(e) => {
                e.target.src = defaultImage;
              }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography.Text
              style={{
                fontWeight: 700,
                fontSize: 16,
                color: "#0f172a",
              }}
            >
              {displayName}
            </Typography.Text>
            <Typography.Text
              style={{ fontSize: 12, color: logoBlue, fontWeight: 500 }}
            >
              Espace IPM connecté
            </Typography.Text>
          </div>
        </div>
      </Menu.Item>
      <Menu.Divider style={{ margin: "0 20px", borderTopColor: "rgba(148, 163, 184, 0.2)" }} />
      <Menu.Item
        key="profil"
        onClick={handlepagemdp}
        style={{
          padding: "12px 20px",
          display: "flex",
          alignItems: "center",
          gap: 14,
          fontWeight: 600,
          color: "#0f172a",
        }}
      >
        <span
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: `${logoBlue}1f`,
            color: logoBlue,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
          }}
        >
          <UserOutlined />
        </span>
        <span style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography.Text style={{ fontWeight: 600, color: "#0f172a" }}>
            Mon profil
          </Typography.Text>
          <Typography.Text style={{ fontSize: 12, color: "#64748b" }}>
            Modifier mes informations
          </Typography.Text>
        </span>
      </Menu.Item>
      <Menu.Item
        key="logout"
        onClick={logout}
        style={{
          padding: "12px 20px",
          display: "flex",
          alignItems: "center",
          gap: 14,
          fontWeight: 600,
          color: "#dc2626",
        }}
      >
        <span
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "rgba(220, 38, 38, 0.12)",
            color: "#dc2626",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
          }}
        >
          <LogoutOutlined />
        </span>
        <span style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography.Text style={{ fontWeight: 600, color: "#dc2626" }}>
            Déconnexion
          </Typography.Text>
          <Typography.Text style={{ fontSize: 12, color: "#ef4444" }}>
            Se déconnecter maintenant
          </Typography.Text>
        </span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout style={{ minHeight: "100vh" }}>
      {contextHolder}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={260}
        style={{
          background: "#ffffff",
          color: "#ff7900",
          minHeight: "100vh",
        }}
      >
        {/* <div className="demo-logo-vertical" /> */}
        {/*  <Menu
         // theme="dark"
         style={{
          background:"#449df2"
         }}
          mode="inline"
          defaultSelectedKeys={['1']}
          items={[
            {
              key: '1',
              icon: <UserOutlined />,
              label: 'nav 1',
            },
            {
              key: '2',
              icon: <VideoCameraOutlined />,
              label: 'nav 2',
            },
            {
              key: '3',
              icon: <UploadOutlined />,
              label: 'nav 3',
            },
          ]}
        /> */}

        <div
          style={{
            width: "100%",
            padding: "10px 0",
            borderBottom: "2px solid #FFFF",
            marginBottom: "16px",
            boxSizing: "border-box",
          }}
        >
          <img
            src={logoEntete}
            alt="Logo"
            style={{
              width: "100%",
              display: "block",
              objectFit: "contain",
            }}
          />
        </div>

        <SideMenu />
        {!collapsed && <SideIllustration />}
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: "linear-gradient(180deg, #ffffff 0%, #f6f9fe 100%)",
            borderBottom: `1px solid ${logoBlue}29`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
              display: "flex",
              flexDirection: "left",
              color: logoBlue,
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "16px",
              color: logoBlue,
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            <span style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontWeight: "bolder",
              fontSize: "17px",
              letterSpacing: "0.3px",
            }}>
              <span role="img" aria-label="sparkles" style={{ fontSize: 18 }}>✨</span>
              Bienvenue dans votre <span style={{ color: logoOrange }}>espace IPM</span> personnel
              <span role="img" aria-label="rocket" style={{ fontSize: 18 }}>🚀</span>
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 20,
              paddingRight: 24,
            }}
          >
            <Button
              shape="circle"
              size="large"
              onClick={() => navigate("/dashboard")}
              icon={<HomeOutlined style={{ fontSize: 22 }} />}
              style={{
                background: `linear-gradient(135deg, ${logoBlue} 0%, ${logoBlueLight} 100%)`,
                color: "#ffffff",
                border: "none",
                boxShadow: `0 10px 24px ${logoBlue}59`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  `0 16px 32px ${logoBlue}59`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  `0 10px 24px ${logoBlue}59`;
              }}
              aria-label="Accueil"
              title="Accueil"
            />

            <NotificationBell color={logoBlue} />

            <Dropdown
              overlay={gestionMenu}
              trigger={["click"]}
              placement="bottomRight"
            >
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "6px 18px 6px 8px",
                  background: `${logoBlue}0d`,
                  borderRadius: 999,
                  border: `1px solid ${logoBlue}33`,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = `${logoBlue}1a`;
                  e.currentTarget.style.border =
                    `1px solid ${logoBlue}66`;
                  e.currentTarget.style.boxShadow =
                    `0 12px 30px ${logoBlue}2e`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = `${logoBlue}0d`;
                  e.currentTarget.style.border =
                    `1px solid ${logoBlue}33`;
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    padding: 2,
                    background:
                      `linear-gradient(135deg, ${logoBlue}, ${logoBlueLight})`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Image
                    src={`${api_URL}Participant/getPhoto/${numcont}`} // Construire dynamiquement l'URL
                    alt="Membre"
                    preview={false}
                    width={44}
                    height={44}
                    style={{
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid #ffffff",
                    }}
                    onError={(e) => {
                      e.target.src = defaultImage;
                    }}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Typography.Text
                    style={{
                      fontWeight: 700,
                      fontSize: 15,
                      color: "#0f172a",
                      lineHeight: 1.15,
                    }}
                  >
                    {displayName}
                  </Typography.Text>
                  <Typography.Text
                    style={{
                      fontSize: 12,
                      color: "#64748b",
                      lineHeight: 1.1,
                    }}
                  >
                    Gérer mon compte
                  </Typography.Text>
                </div>
                <DownOutlined style={{ color: logoBlue, fontSize: 14 }} />
              </div>
            </Dropdown>
          </div>

        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 380,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <ContentBody />
        </Content>
        <Footer
          style={{
            textAlign: "center",
          }}
        >
          WebLamps © V2 - 2025 Created by A2SMI
        </Footer>
      </Layout>
    </Layout>
  );
};
export default LayoutComp;
